module.exports = __webpack_public_path__ + "img/myo-logo-blanc.6fbbb732.png";